import { Platform } from "react-native";
import { NitroModules } from "react-native-nitro-modules";
import { rethrowNativeError } from "../nativeError";
import { MapServices as unavailableMapServices } from "./unavailable";
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = NitroModules.createHybridObject("OneMapServices");
  return hybrid;
}
function search(query, center) {
  var radiusMeters = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5e3;
  return native().search(query, center, radiusMeters).catch(rethrowNativeError);
}
function autocomplete(query, center) {
  var radiusMeters = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5e3;
  return native().autocomplete(query, center, radiusMeters).catch(rethrowNativeError);
}
function resolveSuggestion(id) {
  return native().resolveSuggestion(id).catch(rethrowNativeError);
}
function directions(origin, destination) {
  var transport = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "driving";
  return native().directions(origin, destination, transport).catch(rethrowNativeError);
}
var nativeMapServices = Object.freeze({
  search,
  autocomplete,
  resolveSuggestion,
  directions
});
var androidMapServices = Object.freeze({
  search: nativeMapServices.search,
  autocomplete: unavailableMapServices.autocomplete,
  resolveSuggestion: unavailableMapServices.resolveSuggestion,
  directions: unavailableMapServices.directions
});
var MapServices = Platform.OS === "android" ? androidMapServices : nativeMapServices;
export {
  MapServices
};
//# sourceMappingURL=index.native.js.map
